import React, { useState, useEffect } from "react";
import { Modal, Input, Descriptions } from "antd";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

const { TextArea } = Input;

export default function ContactUsModal() {

  const general = useGeneralStore();
  const visible = general.view.contactUsModal;
  const item = general.view.itemModal;
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (item) {
      setMessage(item.Note);
    }
  }, [item]);

  const handleContactUsCancel = () => {
    general.ToggleContactUsModal();
  };

  const handleStoreMessage = () => {
    general.postContactUsMessage({
      Status: 0,
      Id: item.Id,
      Note: message,
      ContactUsTypeId: null,
    }
    );
    general.ToggleContactUsModal();
  };

  const handleStoreConfirmMessage = () => {
    general.postContactUsMessage({
      Status: 2,
      Id: item.Id,
      Note: message,
      ContactUsTypeId: null,
    }
    );
    general.ToggleContactUsModal();
  };

  return (
    <div>
      <Modal
        width={800}
        title={"پاسخ دهی"}
        className="custom-table"
        open={visible}
        footer={false}
        onCancel={() => general.ToggleContactUsModal()}
      >
        <div className="ticket-details">
          {item && item.Description && (
            <Descriptions className="contactUs-style" size="small">
              <Descriptions.Item label="متن سوال">
                {item.Description}
              </Descriptions.Item>
            </Descriptions>
          )}
          <div>
            <div className="contactUs-lable"> یادداشت :</div>
            <TextArea
              name="message"
              value={message}
              className="animated fadeIn"
              autoSize={{ minRows: 6, maxRows: 8 }}
              maxLength={3000}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button
              type="primary"
              htmltype="submit"
              className="btn contact-button-cancel waves-effect waves-light"
              onClick={() => handleContactUsCancel()}
            >
              انصراف
            </button>
            <button
              type="primary"
              htmltype="submit"
              className="btn contact-button-store waves-effect waves-light"
              onClick={() => handleStoreMessage()}
            >
              ذخیره یادداشت
            </button>
            <button
              type="primary"
              htmltype="submit"
              className="btn btn-success waves-effect waves-light"
              onClick={() => handleStoreConfirmMessage()}
            >
              ذخیره یادداشت و تایید
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
